define([
	"dojo/_base/declare",
	"csi/table/New"
], function(declare,New) {

	return declare(New, {

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set value for season to the parent season and make it read only
			view.addFixedValue("ShapeSeasons", [this.m_urlParent]);
			this.inherited(arguments);
		}

	});
});